import { ApolloProvider } from '@apollo/client'

import { client } from 'lib'

const AplProvider = ({ children }) => <ApolloProvider client={client}>{children}</ApolloProvider>

export default AplProvider
